module.exports = __webpack_public_path__ + "img/icon-ingles-colorido.e3514012.svg";